import { extendServiceContainer } from '@iotize/tap';
import { LoraService } from './service';

declare module '@iotize/tap/lib/service-container' {
  interface ServiceContainer {
    lora: LoraService;
  }
}

export const _TAP_SERVICE_EXTENSION_LORA_ = extendServiceContainer(
  'lora',
  LoraService,
);
